import addAnswer from "app/api/requests/Messages/addAnswerRequest";
import delMessage from "app/api/requests/Messages/delMessageRequest";
import getMessages from "app/api/requests/Messages/getMessagesRequest";

export default {
  addAnswer,
  delMessage,
  getMessages
};
